import { render, staticRenderFns } from "./AudioSettings.vue?vue&type=template&id=cb1854ce&scoped=true&"
import script from "./AudioSettings.vue?vue&type=script&lang=js&"
export * from "./AudioSettings.vue?vue&type=script&lang=js&"
import style0 from "./AudioSettings.vue?vue&type=style&index=0&id=cb1854ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb1854ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3547940844/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cb1854ce')) {
      api.createRecord('cb1854ce', component.options)
    } else {
      api.reload('cb1854ce', component.options)
    }
    module.hot.accept("./AudioSettings.vue?vue&type=template&id=cb1854ce&scoped=true&", function () {
      api.rerender('cb1854ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/AudioSettings.vue"
export default component.exports